module.exports = __webpack_public_path__ + "static/media/login_bg.4ef605b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login_bg.jpg
// module id = 1570
// module chunks = 0